export default "__VITE_ASSET___9WWugtk__"